<template>
    <div>
        <v-app class="p-4">
            <div class="px-5 mt-5">
                <v-row :class="Object.keys(editProps)<=0 ? 'mt-5': ''">
                    <v-col>
                        <v-text-field
                                v-model="textCategory"
                                label="دسته آگهی"
                                outlined
                                dense
                                :error-messages="catMessage"
                                list="groups"
                                prepend-inner-icon="fa fa-pencil-alt"
                                class="mt-5"
                        ></v-text-field>
                        <datalist id="groups">
                            <option v-for="item of categories" :value="item.category">{{ item.category }}</option>
                        </datalist>
                    </v-col>
                    <v-col>
                        <v-text-field
                                v-model="title"
                                label=" پیشفرض عنوان آگهی"
                                outlined
                                :error-messages="errorMessage"
                                clearable clear-icon="mdi-close-circle-outline"
                                counter="50"
                                dense
                                name="title"
                                min="3"
                                max="50"
                                :rules="[(v)=> v.length > 3 || 'تعداد کاراکتر وارد شده کمتر از حد مجاز است.' , (v)=> v.length < 51 || 'تعداد کاراکتر وارد شده بیش از حد موردنیاز است.' ]"
                                prepend-inner-icon="mdi-emoticon"
                                @click:prepend-inner="titlemojiShow = true"
                                class="mt-5"
                        ></v-text-field>
                        <v-sheet v-if="titlemojiShow === true" class="mb-1" color="white lighten-3"
                                 outlined
                                 rounded>
                            <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                                <button type="button" v-for="item in titleEmojies"
                                        class="btn my-1  align-content-center py-1"
                                        @click="emojiPickertitle"
                                        :data-emoji="item">{{ item }}
                                </button>
                            </v-card-text>
                            <v-btn color="error" text @click="titlemojiShow = false"><i
                                    class="fa fa-times text-danger"></i></v-btn>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-textarea
                        v-model="textDescription"
                        label=" پیشفرض متن آگهی"
                        outlined
                        :rules="[(v)=> v.length > 9 || 'تعداد کاراکتر وارد شده کمتر از حد مجاز است.' , (v)=> v.length < 1001 || 'تعداد کاراکتر وارد شده بیش از حد موردنیاز است.' ]"
                        name="description"
                        min="10"
                        clearable clear-icon="mdi-close-circle-outline"
                        max="1000"
                        counter="1000"
                        prepend-inner-icon="mdi-emoticon"
                        @click:prepend-inner="mojiShow = true"
                        dense
                ></v-textarea>
                <v-sheet v-if="mojiShow === true" class="mb-1" color="white lighten-3"
                         outlined
                         rounded>
                    <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                        <button type="button" v-for="item in descEmojies"
                                class="btn my-1  align-content-center py-1"
                                @click="emojiPickerdesc"
                                :data-emoji="item">{{ item }}
                        </button>
                    </v-card-text>
                    <v-btn color="error" text @click="mojiShow = false"><i class="fa fa-times text-danger"></i></v-btn>
                </v-sheet>
                <v-btn class="submit-btn float-left text-white" v-if="Object.keys(editProps).length <= 0"
                       @click="submit">
                    <span class="material-icons">save</span>
                    ثبت متن
                </v-btn>
                <v-btn class="btn-upload float-left text-white" v-else-if="Object.keys(editProps).length > 0"
                       @click="Update">
                    <span class="material-icons">save</span>
                    به روزرسانی متن
                </v-btn>
            </div>
        </v-app>
    </div>
</template>

<script>


import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Swal from "sweetalert2";
import {Bus} from "@/main";

export default {
    name: "createDefaultText",
    components: {TitleRibbon},
    props: {
        editProps: {
            type: Object,
            default: ({})
        }
    },
    data() {
        return {
            textCategory: '',
            errorMessage: '',
            catMessage: '',
            categories: [],
            mojiShow: false,
            titlemojiShow: false,
            textDescription: '',
            title: '',
            descEmojies: ["✌️", "✅", "♻️", "❎", "✳️", "❇️", "✔️", "☑️", "⚫", "⚪", "▪️", "▫️", "◾", "◽", "◼️", "◻️", "⬛", "⬜", "♾️", "✖️", "➗", "➖", "➕", "↩️", "↪️", "⤵️", "⤴️", "↔️", "↕️", "↖️", "↙️",
                "↘️", "↗️", "⬇️", "⬆️", "⬅️", "➡️", "◀️", "⏬", "⏫", "⏪", "⏩", "*️⃣", "#️⃣"],
            titleEmojies: ["%", "٪", "*", "×", "،", ".", "-", "+", "«", "»", "&", "'", "(", ")", "/"],
        };
    },
    methods: {
        submit() {
            const data = {
                category: this.textCategory,
                description: this.textDescription,
                title: this.title,
            }
            if (!data.title) {
                this.errorMessage = "عنوان متن پیشفرض خود را وارد کنید."
                return false
            }else if (!data.category){
                this.catMessage = "دسته متن پیشفرض خود را وارد کنید."
                return false
            }else
                this.catMessage=""
                this.errorMessage=""


            $.ajax({
                url: `${url}/default`,
                type: 'POST',
                fn: this.submit,
                headers: {
                    ACCEPT: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: Token
                },
                data: JSON.stringify({
                    data:data,
                    type: "text"
                }),
                success: (data) => {
                    this.$router.push({path: '/adsList/defTextList'})
                },
            });
        },
        Update() {
            const data = {
                data: {
                    category: this.textCategory,
                    title: this.title,
                    description: this.textDescription
                }
            }
            $.ajax({
                url: `${url}/default/${this.editProps.id}`,
                method: "PUT",
                fn: this.Update,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                data: JSON.stringify(data),
                success: function (data) {
                    this.$router.push({path: '/adsList/defTextList'})
                    Bus.$emit('reload');
                }
            })
        },
        getCategories() {
            $.ajax({
                url: `${url}/default/text/all`,
                method: "GET",
                fn: this.getCategories,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                success: (data) => {
                    this.categories = data
                }
            })
        },
        emojiPickerdesc(element) {
            const $title = $('[name = "description"]')[0];

            let currentInput = $title.value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            $title.value = textBefore + $(element.target).data("emoji") + textAfter;
            this.textDescription = $title.value;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
        emojiPickertitle(element) {
            const $title = $('[name = "title"]')[0];

            let currentInput = $title.value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            $title.value = textBefore + $(element.target).data("emoji") + textAfter;
            this.title = $title.value;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
    },
    watch: {
        editProps: function () {
            if (this.editProps != null) {
                this.textCategory = this.editProps.category;
                this.textDescription = this.editProps.description;
                this.title = this.editProps.title;
            } else {
                return false;
            }
        },
        title: function (value) {
            const count = (value.match(/[%٪\*×،\.\-\+«»&'\(\)\/]/g) || []).length
            if (count > 4 || value.match('#')) {
                this.errorMessage = 'عنوان آگهی تنها می‌تواند شامل حروف الفبا، اعداد و 4 نوع از علامت‌های % ٪ * × ، . - + « » & \' ( ) / باشد';
                this.iconIndex = 1;
            } else {
                this.errorMessage = '';
            }
        },
    },
    mounted() {
        this.getCategories();
        this.$route.meta.has_ribbon= Object.keys(this.editProps).length <= 0
    }
}

</script>

<style scoped>
.btn-grad {
    background-image: linear-gradient(to right, #000046 0%, #1CB5E0 51%, #000046 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.7s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
}

.btn-grad:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
    transition: 0.7s;
}
</style>